<template>
  <el-dialog
    title
    class="close_dia"
    :visible.sync="centerDialogVisible"
    :before-close="closeDialog"
    width="100%"
    center
  >
    <div class="close_img">
      <img :src="imgUrl" alt />
    </div>
    <div class="success_txt">提交成功</div>
    <div class="other_txt">
      我们将尽快为您处理
      <br />
      <span class="move_stime">{{timeNum}}s&nbsp;</span>后自动跳转到举报列表
    </div>
    <div class="goBack" @click="closeDialog">返回举报列表</div>
  </el-dialog>
</template>

<script>
import imgUrl from "@/assets/images/close.png";
export default {
  props: {
    isDialogVisible: {
      type: Boolean,
      default: false
    }
  },
  name: "submitSuccess",
  data() {
    return {
      imgUrl,
      timeNum: 60,
      timer: null,
      centerDialogVisible: false
    };
  },
  methods: {
    closeDialog() {
      this.centerDialogVisible = false;
      this.$emit("changeDialogVal", false);
      this.$router.push({ path: "/ReportPlatform/ReportList" });
    },
    setTime() {
      this.timer = setInterval(() => {
        this.timeNum--;
        if (this.timeNum == 0) {
          this.timeNum = 60;
          clearInterval(this.timer);
          this.$router.push({ path: "/ReportPlatform/ReportList" });
        }
      }, 1000);
    }
  },
  destroyed() {
    if (this.timer) {
      //如果定时器在运行则关闭
      clearInterval(this.timer);
    }
  },
  watch: {
    isDialogVisible(val) {
      this.setTime();
      this.centerDialogVisible = val;
    }
  }
};
</script>

<style scoped>
.close_dia {
  margin: 0 auto;
  max-width: 525px;
}
.close_dia >>> .el-dialog__headerbtn {
  display: none;
}
.close_img {
  height: 140px;
  text-align: center;
}
.success_txt {
  margin: 20px 0 10px;
  font-size: 24px;
  color: #0f1824;
  text-align: center;
}
.other_txt {
  font-size: 16px;
  color: #b6bcc2;
  text-align: center;
  margin-bottom: 35px;
  line-height: 20px;
}
.move_stime {
  color: #3165ff;
}
.goBack {
  cursor: pointer;
  width: 100px;
  height: 28px;
  text-align: center;
  margin: 0 auto;
  color: #fff;
  background: #3165ff;
  border-radius: 2px;
  line-height: 28px;
  margin-bottom: 30px;
}
</style>
